import { ResourceSubPipeline } from "../../utils";
import { zOrder } from "./order-resource";

function getOrderServiceProjectSubPipeline(): ResourceSubPipeline {
  return {
    mainStages: [
      {
        $unwind: {
          path: "$items",
          preserveNullAndEmptyArrays: true,
        },
      },
      {
        $lookup: {
          from: "serviceprojects",
          localField: "items.serviceProjectId",
          foreignField: "_id",
          as: "serviceProjectDoc",
        },
      },
      {
        $addFields: {
          "items.serviceProjectDoc": "$serviceProjectDoc",
        },
      },
      {
        $unwind: {
          path: "$items.serviceProjectDoc",
          preserveNullAndEmptyArrays: true,
        },
      },
      {
        $lookup: {
          from: "users",
          localField: "items.serviceProjectDoc.professionalId",
          foreignField: "_id",
          as: "items.serviceProjectDoc.professionalDoc",
        },
      },
      {
        $unwind: {
          path: "$items.serviceProjectDoc.professionalDoc",
          preserveNullAndEmptyArrays: true,
        },
      },
      {
        $group: {
          _id: "$_id",
          items: { $push: "$items" },
          total: { $first: "$total" },
          userId: { $first: "$userId" },
          orderNumber: { $first: "$orderNumber" },
          totalTax: { $first: "$totalTax" },
          subtotalTaxExclusive: { $first: "$subtotalTaxExclusive" },
          createdAt: { $first: "$createdAt" },
          updatedAt: { $first: "$updatedAt" },
        },
      },
    ],

    projectStage: {
      "items.serviceProjectDoc.serviceDetails.title": 1,
      "items.serviceProjectDoc.professionalDoc.firstName": 1,
      "items.serviceProjectDoc.professionalDoc.lastName": 1,
      "items.servicePackagePrice": 1,
      "items.tax": 1,
      "items.itemTotalTaxExclusive": 1,
    },
  };
}

function getOrderUserSubPipeline(): ResourceSubPipeline {
  return {
    mainStages: [
      {
        $lookup: {
          from: "users",
          localField: "userId",
          foreignField: "_id",
          as: "userDoc",
        },
      },
      {
        $unwind: {
          path: "$userDoc",
          preserveNullAndEmptyArrays: true,
        },
      },
    ],

    projectStage: {
      "userDoc.firstName": 1,
      "userDoc.lastName": 1,
      "userDoc.billingAddress": 1,
      "userDoc.phoneNumber": 1,
    },
  };
}

export function getOrderPipeline() {
  const serviceProjectPipeline = getOrderServiceProjectSubPipeline();
  const userDocPipeline = getOrderUserSubPipeline();

  return {
    _z: zOrder,
    mainStages: [...serviceProjectPipeline.mainStages, ...userDocPipeline.mainStages],
    projectStage: {
      _id: 1,
      total: 1,
      orderNumber: 1,
      totalTax: 1,
      createdAt: 1,
      updatedAt: 1,
      subtotalTaxExclusive: 1,
      ...serviceProjectPipeline.projectStage,
      ...userDocPipeline.projectStage,
    },
  };
}
